import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "black"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "black"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "search-bar" }
const _hoisted_6 = { class: "list-entries" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "selected-country"
}
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "selected" }
const _hoisted_11 = { class: "selected-12px" }
const _hoisted_12 = { class: "selected" }
const _hoisted_13 = {
  key: 1,
  class: "country"
}
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "black" }
const _hoisted_16 = { class: "grey-small" }
const _hoisted_17 = { class: "black" }
const _hoisted_18 = {
  key: 2,
  style: {"position":"relative"}
}
const _hoisted_19 = { class: "disabledShowBox" }
const _hoisted_20 = {
  key: 0,
  class: "black",
  style: {"color":"#a6a6a6"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: {"position":"relative"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.insideClick = true))
        }, [
          (_ctx.showError)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([_ctx.codePickerShown ? 'showBox error' : 'dontShowBox error']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleCodePicker()))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", {
                    class: _normalizeClass(_ctx.currentCode !== '' || _ctx.newCode !== '0' ? 'grey-small' : 'grey')
                  }, "Country", 2),
                  (_ctx.currentCode !== '0' || _ctx.newCode !== '0')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.shownCode), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("img", {
                  class: "small-img",
                  src: _ctx.codePickerShown ? 'https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/up.svg' : 'https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/down.svg'
                }, null, 8, _hoisted_2)
              ], 2))
            : _createCommentVNode("", true),
          (!_ctx.showError)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([_ctx.codePickerShown ? 'showBox' : 'dontShowBox']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleCodePicker()))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", {
                    class: _normalizeClass(_ctx.currentCode !== '' || _ctx.newCode !== '0' ? 'grey-small' : 'grey')
                  }, "Country", 2),
                  (_ctx.currentCode !== '0' || _ctx.newCode !== '0')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.shownCode), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("img", {
                  class: "small-img",
                  src: _ctx.codePickerShown ? 'https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/up.svg' : 'https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/down.svg'
                }, null, 8, _hoisted_4)
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.codePickerShown && !_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "code-picker-shown",
          style: _normalizeStyle(_ctx.showAbove ? 'bottom: 104px' : 'top: 158px;'),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.insideClick = true))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: "search",
              type: "text",
              placeholder: "Search country code",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event))
            }, null, 512), [
              [_vModelText, _ctx.search]
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("img", {
              class: "search-img",
              src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/magnifier.svg"
            }, null, -1))
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "br-line" }, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountryCodes(), (country, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                onClick: ($event: any) => (_ctx.pickCountryCode(country))
              }, [
                (_ctx.shownCode === '+' + country.CallingCode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", _hoisted_10, _toDisplayString(country.nativeCountry), 1),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(country.country), 1)
                      ]),
                      _createElementVNode("p", _hoisted_12, "+" + _toDisplayString(country.CallingCode), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(country.nativeCountry), 1),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(country.country), 1)
                      ]),
                      _createElementVNode("p", _hoisted_17, "+" + _toDisplayString(country.CallingCode), 1)
                    ]))
              ], 8, _hoisted_7))
            }), 128))
          ])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("p", {
                class: "grey-small",
                style: {"color":"#a6a6a6"}
              }, "Country", -1)),
              (_ctx.currentCode !== '0' || _ctx.newCode !== '0')
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.shownCode), 1))
                : _createCommentVNode("", true)
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("img", {
              class: "small-img",
              style: {"filter":"invert(75%) sepia(0%) saturate(24%) hue-rotate(212deg) brightness(89%) contrast(89%)"},
              src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/down.svg"
            }, null, -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}